import React from 'react';

const contractorTypes = [
  'Renovation contractors',
  'Fencing contractors',
  'Flooring installers',
  'Roofing and exterior contractors',
  'Basement contractors',
  'Landscaping contractors',
  'General contractors',
  'Small trade businesses',
];

const SocialProofSection = () => {
  return (
    <section className="border-y border-slate-200/80 bg-slate-50/90 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <p className="text-center text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">
          Built for real contractors
        </p>
        <h2 className="mt-2 text-center text-2xl font-bold tracking-tight text-slate-900 md:text-3xl">
          Built for the way real contracting teams operate
        </h2>
        <p className="mx-auto mt-3 max-w-2xl text-center text-sm text-slate-600 md:text-base">
          Built for contractors across Canada and the United States, from solo operators to growing crews managing multiple jobs.
        </p>
        <div className="mt-10 grid grid-cols-2 gap-4 md:grid-cols-2 lg:grid-cols-4 md:gap-5">
          {contractorTypes.map((type) => (
            <div
              key={type}
              className="rounded-2xl border border-slate-200/90 bg-white px-5 py-4 text-center shadow-sm md:px-6 md:py-5"
            >
              <h3 className="text-sm font-semibold text-slate-900 md:text-base">{type}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SocialProofSection;
